import "what-input";
import Vue from "vue";
import { instance } from "./api/instance.js";
import BurgerMenu from "./components/BurgerMenu.vue";
import MegaMenu from "./components/MegaMenu.vue";
import MegaBurgerMenu from "./components/MegaBurgerMenu.vue";
import BurgerFooter from "./components/BurgerFooter.vue";
import GetInTouch from "./components/GetInTouch.vue";
import CoverageList from "./components/CoverageList.vue";
import { gsap, ScrollTrigger } from "gsap/all";

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below

gsap.registerPlugin(ScrollTrigger);

// Locomotive
import LocomotiveScroll from "locomotive-scroll";

// Use API
Vue.prototype.$http = instance;

// Enable to use Vue.js
var vue = new Vue({
  el: "#app",
  components: {
    "burger-menu": BurgerMenu,
    "get-in-touch": GetInTouch,
    "coveragelist" : CoverageList,
    "mega-menu" : MegaMenu,
    "mega-burger-menu" : MegaBurgerMenu,
    "burger-footer" : BurgerFooter,
  },
  data: {
  	menu_active: false,
  	lang_switcher_active: false,
    popup_active: false,
    mega_menu_active: false,
    mega_menu_was_active: false,
    is_scrolled: false,
    name: "Test"
  },
  mounted() {
  },
  methods: {
  	toggle_menu: function() {
      this.menu_active = !this.menu_active;

      if(this.menu_active) {
        document.querySelector('.mega-menu .underlay').classList.add('active');
        document.querySelector('.header-innerlay').classList.add('active');
        document.querySelector('header').classList.add('is-active');
      } else {
        if(!this.is_scrolled) {
          setTimeout(() => {
            document.querySelector('header').classList.remove('is-active');
            document.querySelector('.header-innerlay').classList.remove('active');
            document.querySelector('.mega-menu .underlay').classList.remove('active');
          }, 600);
        } else {
          setTimeout(() => {
            document.querySelector('.header-innerlay').classList.remove('active');
            document.querySelector('.mega-menu .underlay').classList.remove('active');
          }, 600);
        }
      }
  	},
    toggle_popup: function() {
  		this.popup_active = !this.popup_active;
  	},
    toggleLangSwitcher: function() {
        this.lang_switcher_active = !this.lang_switcher_active;
        if(this.lang_switcher_active) {
          document.querySelector('.header-innerlay').classList.add('active');
        } else {
          if(!this.is_scrolled) {
            setTimeout(() => {
              document.querySelector('header').classList.remove('is-active');
              document.querySelector('.header-innerlay').classList.remove('active');
            }, 600);
          }
        }
    },
    closeLangSwitcher: function() {
        if(this.lang_switcher_active) {
          this.lang_switcher_active = false;
          if(!this.is_scrolled) {
            setTimeout(() => {
              document.querySelector('header').classList.remove('is-active');
              document.querySelector('.header-innerlay').classList.remove('active');
            }, 600);
          }
        }
    },
  }
});


(function($) {
    $(document).ready(function() { // Loaded when DOM is ready
      $(window).click(function() {
        vue.closeLangSwitcher();
      });

      $(".lang-menu").click(function(event){
        event.stopPropagation();
      });
      $(".current-lang").click(function(event){
        event.stopPropagation();
      });


      if($(".flex-block.live_matches").length) {
        fetch(site_vars.home_url + "wp-json/cm/v1/live-matches")
        .then(data => {
          return data.json();
        })
        .then(data => {
          document.querySelector(".total-live-matches-flex").innerHTML = data.live_matches;
        });

        fetch(site_vars.home_url + "wp-json/cm/v1/live-matches-full")
        .then(data => {
          return data.json();
        })
        .then(data => {
          let html = "";
          data.forEach((match, i) => {
            const sportStatusClass = match.live ? "live-sport" : "not-live";
            let divClasses = "col-6 col-md-4 col-lg-3 text-center single-sport hidden-sport d-none";
            if(i < 40) {
              divClasses = "col-6 col-md-4 col-lg-3 text-center single-sport";
            }
            html += `
              <div class="${divClasses}">
                <p class="${sportStatusClass}">
                  ${match.sport_name}
                  ${match.live ? `<div class="live-matches"><div class="live-indicator">${match.live_matches}</div></div>` : ""}
                </p>
              </div>
            `;
          });

          document.querySelector(".live-matches-row").innerHTML = html;
        });
      }

        $(function(){
          if($('.rotating-slider').length) {
            $('.rotating-slider').each((i, item) => {
              const index = $(item).data('index');
              $('.rotating-slider-' + index).rotatingSlider({
                slideHeight : Math.min(600, window.innerWidth -80),
                slideWidth : Math.min(350, window.innerWidth - 80),
              });
            })
          }
        });

       let scroll;
       function initLocoScroll() {
          // const urlParams = new URLSearchParams(window.location.search);
          // let disableSmooth = urlParams.get('disable_smooth') ? urlParams.get('disable_smooth') === 'true' : false;
          // if(document.querySelector('.coverage')) {
          //   disableSmooth = true;
          // }
          // let locoOptions = {
          //   el: document.querySelector('[data-scroll-container]'),
          //   smooth: true,
          //   lerp: 0.1
          // };
          // if (disableSmooth) {
          // }
          const locoOptions = {
            el: document.querySelector('[data-scroll-container]'),
            smooth: false,
          };
          scroll = new LocomotiveScroll(locoOptions);
        }
        initLocoScroll();

        $(".show-all-sports").on("click", () => {
          $(".show-all-sports").remove();
          $('.hidden-sport').removeClass('d-none');
          scroll.update();
        })

        $(".toggle-popup-scroll").on("click", () => {
          if(vue.popup_active) {
            stopScroll();
          } else {
            startScroll();
          }
        })

        $(".toggle-menu-scroll").on("click", () => {
          if(vue.menu_active) {
            stopScroll();
          } else {
            startScroll();
          }
        })

        function stopScroll() {
          scroll.stop();
          $("body").css("overflow", "hidden");
        }

        function startScroll() {
          scroll.start();
          $("body").css("overflow", "visible");
        }

        const items = document.querySelectorAll(".accordion button");

        function toggleAccordion() {
          const itemToggle = this.getAttribute("aria-expanded");

          // setTimeout(() => {
          // }, 100);

          for (let i = 0; i < items.length; i++) {
            items[i].setAttribute("aria-expanded", "false");
          }

          if (itemToggle == "false") {
            this.setAttribute("aria-expanded", "true");
          }
          scroll.update();
        }

        items.forEach(item => item.addEventListener("click", toggleAccordion));

        new ResizeObserver(() => {
          scroll.update();
        }).observe(document.querySelector("[data-scroll-container]"))

        //sticky menu
        const body = document.body;
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";
        let lastScroll = 0;
        let quoteAuto = false;

        // $('.site-header:not(.is-active)').addEventListener('mouseover', () => {
        //   console.log("MOUSE OVER");
        // });
        //
        $(".site-header:not(.is-active):not(.is-always-active)").mouseover(function() {
          $("header").addClass("is-active");
        });

        $(".site-header:not(.is-active):not(.is-always-active)").mouseleave(function() {
          if(!vue.is_scrolled && !vue.lang_switcher_active && vue.mega_menu_was_active) {
            setTimeout(() => {
              $("header").removeClass("is-active");
            }, 600);
          } else if(!vue.lang_switcher_active && !vue.is_scrolled) {
            $("header").removeClass("is-active");
          }
        });

        scroll.on("scroll", (position) => {
          document.querySelector(".is-inview").classList.add("stay-active");

          if ((position.scroll.y) >= 50) {
            vue.is_scrolled = true;
            $("body").addClass("is-scrolled");
            $("header").addClass("is-active");
          } else {
            vue.is_scrolled = false;
            $("body").removeClass("is-scrolled");
            $("header").removeClass("is-active");
          }

          $(".mega-menu .menu-item.has-children").each(function() {
            $(this).mouseover(function() {
              vue.mega_menu_active = true;
              vue.mega_menu_was_active = true;
              $(".mega-menu .underlay").addClass("active");
              $(".header-innerlay").addClass("active");
            });

            $(this).mouseleave(function() {
              vue.mega_menu_active = false;
              setTimeout(() => {
                if(!vue.mega_menu_active) {
                  vue.mega_menu_was_active = false;
                  $(".mega-menu .underlay").removeClass("active");
                  $(".header-innerlay").removeClass("active");
                }
              }, 500);
            });
          });

          const currentScroll = position.scroll.y;
          if (currentScroll <= 0) {
            body.classList.remove(scrollUp);
            return;
          }

          if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
            // down
            body.classList.remove(scrollUp);
            body.classList.add(scrollDown);
          } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
            // up
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
          }
          lastScroll = currentScroll;
        });


        $('.load-more-btn').click(function(){
          var button = $(this),
              data = {
            'action': 'loadmore',
            'query': site_vars.posts, // that's how we get params from wp_localize_script() function
            'page' : site_vars.current_page
          };

          $.ajax({ // you can also use $.post here
            url : site_vars.ajax_url, // AJAX handler
            data : data,
            type : 'POST',
            beforeSend : function ( xhr ) {
              button.text('Loading...'); // change the button text, you can also add a preloader image
            },
            success : function( data ){
              if( data ) {

                $(".news-archive .post-row").append(data);
                // button.text( 'More posts' ).prev().after(data); // insert new posts
                site_vars.current_page++;
                setTimeout(() => {
                  scroll.update();
                }, 500);

                if ( site_vars.current_page == site_vars.max_page ) {
                  button.remove(); // if last page, remove the button
                } else {
                  button.text('Load more');
                }

                // you can also fire the "post-load" event here if you use a plugin that requires it
                // $( document.body ).trigger( 'post-load' );
              } else {
                button.remove(); // if no data, remove the button as well
              }
            }
          });
        });


        // SWIPER
        if($(".quote-swiper").length) {
          $(".quote-swiper-container").each(function( index ) {

            var swiper = new Swiper(this, {
              slidesPerView: 1,
              loop: false,
              allowTouchMove: false,
              autoplay: {
                delay: 10000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
              },
              speed: 1000,
              effect: "fade",
              fadeEffect: {
                crossFade: true
              },
              autoHeight: true,
              centeredSlides: true,
              on: {
                init: function () {
                  $('.quote-swiper-container .progress').addClass('progress-start');
                },
              },
            });

            swiper.on('slideChange', function() {
              $('.quote-swiper-container .progress').removeClass('progress-start');

              setTimeout(() => {
                $('.quote-swiper-container .progress').addClass('progress-start');
              }, 500);

              setTimeout(() => {
                scroll.update();
              }, 1000);
            })

            scroll.on("scroll", () => {
              if($(".quote").hasClass("is-inview")) {
                swiper.autoplay.start();
                $('.quote-swiper-container .progress').addClass('progress-start');
              } else {
                swiper.autoplay.stop();
                $('.quote-swiper-container .progress').removeClass('progress-start');
              }
            })

          });
        }

        if($('.infobox-swiper').length) {
          $('.infobox-swiper-container').each(function( index ) {

            var swiper = new Swiper(this, {
              slidesPerView: 1.2,
              breakpoints: {
                // when window width is >= 480px
                767: {
                  slidesPerView: 2
                },
                // when window width is >= 640px
                992: {
                  slidesPerView: 3
                }
              },
              spaceBetween: 30,
              loop: false,
              freeMode: true,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false
              },
              speed: 2000,
              mousewheel: {
                forceToAxis: true,
              },
              adaptiveHeight: false,
              centeredSlides: false,
            });
          });
        }

      var heroPlayer = document.querySelector('.hero-banner iframe');

      if(heroPlayer) {
        calcIframeHeight();

        window.addEventListener('resize', () => {
          calcIframeHeight();
        });
      }


      function calcIframeHeight() {
        var heroPlayerWidth = heroPlayer.getAttribute("width");
        var heroPlayerHeight = heroPlayer.getAttribute("height");
        var aspect = heroPlayerHeight / heroPlayerWidth;
        var wrapper = document.querySelector(".hero-banner .media");

        wrapper.style.height = wrapper.clientWidth * aspect + 'px';
        heroPlayer.style.width = wrapper.clientWidth + 'px';
        heroPlayer.style.height = wrapper.clientWidth * aspect + 'px';
      }






      // List of Video Vendors embeds you want to support
      var players = ['section:not(.hero-banner) iframe[src*="youtube.com"]', 'section:not(.hero-banner) iframe[src*="vimeo.com"]'];

      // Select videos
      var fitVids = document.querySelectorAll(players.join(","));

      // If there are videos on the page...
      if (fitVids.length) {
        // Loop through videos
        for (var i = 0; i < fitVids.length; i++) {
          // Get Video Information
          var fitVid = fitVids[i];
          var width = fitVid.getAttribute("width");
          var height = fitVid.getAttribute("height");
          var aspectRatio = height / width;
          var parentDiv = fitVid.parentNode;

          // Wrap it in a DIV
          var div = document.createElement("div");
          div.className = "fitVids-wrapper";
          div.style.paddingBottom = aspectRatio * 100 + "%";
          parentDiv.insertBefore(div, fitVid);
          fitVid.remove();
          div.appendChild(fitVid);

          // Clear height/width from fitVid
          fitVid.removeAttribute("height");
          fitVid.removeAttribute("width");
        }
      }

    });
})( jQuery );
